import styled from "styled-components";
export const SelectNative = styled.select `
  position: relative;
  height: 2.5rem;
  width: 100%;
  color: transparent;
  box-sizing: border-box;
  border-radius: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  background-color: ${({ theme }) => theme.colors.white};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: ${({ multiple }) => (multiple ? "0" : "0.5rem")};
  padding-right: ${({ multiple }) => (multiple ? "0" : "2.75rem")};

  ${({ errors, name, outlined, theme, hasInitialSelectionChanged, opened }) => {
    const borderColor = (errors === null || errors === void 0 ? void 0 : errors[name])
        ? theme.colors.error
        : hasInitialSelectionChanged || opened
            ? theme.colors.black
            : theme.colors.grey10;
    const textColor = hasInitialSelectionChanged
        ? theme.colors.black
        : `rgba(${theme.colors.transparentBlack}, 0.36)`;
    return `
      ${!outlined ? "border: none;" : ""}
      border${!outlined ? "-bottom" : ""}: 1px solid ${borderColor};
      color: ${textColor}
    `;
}};

  &:focus {
    ${({ theme, focused }) => focused
    ? `outline: 1px solid ${theme.colors.primaryLight};
        border: 1px solid ${theme.colors.primaryLight};`
    : `outline: none;`}

    ${({ multiple }) => (multiple ? `height: 8rem;` : "height: 2.5rem")};
    ${({ multiple }) => multiple ? `position: absolute; z-index: 1;` : "position: relative;"};

    option {
      ${({ multiple }) => multiple
    ? "&:first-child {display: none;}"
    : `
            &:first-child {
              height: 2.5rem;
              display: flex;
              align-items: center;
              border: 1px solid transparent;
              outline:  1px solid transparent;
              font-weight: inherit;
              padding: 0;
            }
            `}
    }
  }

  &:active {
    transition:
      background-color,
      border-color 0.3s ${({ opened }) => (opened ? "ease-in" : "ease-out")};
    background-color: ${({ theme, outlined }) => outlined
    ? theme.colors.grey05
    : `rgba(${theme.colors.transparentBlack}, 0.06)`};
    ${({ outlined, theme, errors }) => {
    if (errors && Object.keys(errors).length > 0) {
        return "";
    }
    return `
        ${!outlined ? "border: none;" : ""}
        border${!outlined ? "-bottom" : ""}: 1px solid ${theme.colors.black};
        `;
}}
  }

  color: ${({ theme }) => theme.colors.black};

  &:disabled,
  &:disabled:active,
  &:disabled:hover {
    background-color: ${({ readOnly, theme, outlined }) => {
    if (!outlined)
        return "transparent";
    if (readOnly)
        return theme.colors.grey04;
    return theme.colors.grey03;
}};
    ${({ outlined, theme }) => `
      ${!outlined ? "border: none;" : ""}
      border${!outlined ? "-bottom" : ""}: 1px solid rgba(${theme.colors.transparentBlack},${!outlined ? "0.26" : "0"});`};
    color: ${({ theme, readOnly }) => readOnly
    ? theme.colors.black
    : `rgba(${theme.colors.transparentBlack}, 0.26)`};
  }

  @media (hover: hover) {
    &:focus {
      & + div {
        display: none;
      }
    }
  }

  ${({ $forceCustom }) => !$forceCustom &&
    `
  @media ${({ theme }) => theme.device.touch} {
    height: ${({ multiple }) => `${multiple ? "auto" : "2.75rem"}`};
  }`}

  ${({ $forceCustom }) => $forceCustom &&
    `
    &:focus {
      & + div {
        display: none;
      }
    }
  `}
`;
export const Placeholder = styled.option `
  ${({ theme }) => `color: rgb(${theme.colors.transparentBlack}, 0.36);`}
`;
